import React, { useEffect } from 'react';
import { AuthenticatorQrCode } from '../../../shared/authenticator-qr-code/authenticator-qr-code';
import { useEnrollmentAuthenticatorVerifyMutation } from '../../../slices/auth-api.slice';
import { useSelector } from 'react-redux';
import { selectAuthenticator } from '../../../slices/registration.slice';
import { StepsProps } from '@workday/upc-common';
import { useTranslation } from 'react-i18next';

type RegisterAuthenticatorProps = StepsProps;

export function RegisterAuthenticator({ steps }: RegisterAuthenticatorProps) {
    const [authenticatorVerify, enrollmentAuthenticatorVerifyMutation] = useEnrollmentAuthenticatorVerifyMutation();
    const { t } = useTranslation();

    const authenticator = useSelector(selectAuthenticator);

    useEffect(() => {
        if (enrollmentAuthenticatorVerifyMutation.isSuccess) {
            steps.next();
        }
    }, [steps, enrollmentAuthenticatorVerifyMutation]);

    function onSubmitPasscode(payload) {
        authenticatorVerify(payload);
    }

    return (
        <div className='registerAuthenticator'>
            <AuthenticatorQrCode
                title={t('Authenticator.title')}
                disabled={enrollmentAuthenticatorVerifyMutation.isLoading}
                authenticator={authenticator}
                mutation={enrollmentAuthenticatorVerifyMutation}
                onSubmit={onSubmitPasscode}
            />
        </div>
    );
}
